import {createAction, props} from '@ngrx/store';

export enum PageNotFoundActions {
  SetPageNotFound = '[PageNotFound Component] Set page not found',
  ResetPageNotFound = '[PageNotFound Component] Reset page not found',
  SetRedirectUrl = '[PageNotFound Component] Set redirect url',
}

export const setPageNotFound = createAction(PageNotFoundActions.SetPageNotFound);
export const resetPageNotFound = createAction(PageNotFoundActions.ResetPageNotFound);
export const setRedirectUrl = createAction(PageNotFoundActions.SetRedirectUrl, props<{redirectUrl: string}>());
